module.exports = __webpack_public_path__ + "img/r.48e7f0c2.svg";